if (!customElements.get("card-slider")) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions =
        JSON.parse(this.getAttribute("data-swiper-options")) || {};

      window.addEventListener("shopify:section:load", () => {
        this.initSlider(swiperOptions);
      });

      this.initSlider(swiperOptions);

      if (this.classList.contains("js-testimonials")) {
        const initOrUpdateSlider = () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect =
            this.slider && this.slider.params.effect === "slide";

          if ((isMobile && !isSlideEffect) || (!isMobile && isSlideEffect)) {
            this.reInitSlider(swiperOptions);
          }
        };

        initOrUpdateSlider();
        window.addEventListener("resize", initOrUpdateSlider);
      }

      window.addEventListener("resize", () => {
        if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
          if (this.slider) this.slider.destroy();
        } else if (!this.slider) {
          this.initSlider(swiperOptions);
        }
      });
    }

    reInitSlider(swiperOptions) {
      if (this.slider) this.slider.destroy();
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      const isMobile = window.innerWidth < 750;

      if (swiperOptions.disabledOnMobile && isMobile) return;

      // ---------- PAGINATION ----------
      if (swiperOptions.pagination === "render_bullet") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (i, className) =>
            `<button class="${className}"><span>${i + 1}</span></button>`
        };
      } else if (swiperOptions.pagination === "progressbar") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          type: "progressbar"
        };
      } else if (swiperOptions.pagination === "bullets") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          clickable: true
        };
      } else {
        swiperOptions.pagination = false;
      }

      if (swiperOptions.loop && swiperOptions.slideCount < 2) {
        swiperOptions.loop = false;
      }

      // ---------- BASE OPTIONS ----------
      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1.1,
        spaceBetween: swiperOptions.spaceBetweenMobile ?? 16,
        resistanceRatio: 0.72,
        // scope the default arrows to this slider's own section (a document-wide selector grabs the first
        // arrows on the page, e.g. the product gallery's, and fights over their disabled state)
        navigation: swiperOptions.navigation || {
          nextEl: this.closest(".shopify-section")?.querySelector(".swiper-button--next"),
          prevEl: this.closest(".shopify-section")?.querySelector(".swiper-button--prev")
        },
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop ?? 16
          }
        }
      };

      // ---------- VARIANTS ----------
      if (this.classList.contains("horizontal-w-media")) {
        sliderOptions = {
          ...sliderOptions,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 1
            }
          }
        };
      }

      if (this.classList.contains("carousel-none-media")) {
        sliderOptions = {
          ...sliderOptions,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 3.2
            }
          }
        };
      }

      // =====================================================
      // ✅ GLOBAL SMOOTH HORIZONTAL SCROLL ON MOBILE
      // =====================================================
      if (isMobile) {
        sliderOptions.slidesPerView = "auto";
        sliderOptions.spaceBetween =
          swiperOptions.spaceBetweenMobile ?? 16;

        sliderOptions.freeMode = {
          enabled: true,
          momentum: true,
          momentumBounce: false,
          momentumVelocityRatio: 0.8
        };

        sliderOptions.resistance = false;
        sliderOptions.grabCursor = true;
        sliderOptions.watchSlidesProgress = true;

        // vypneme snap správanie
        sliderOptions.loop = false;
        sliderOptions.rewind = false;
      }

      // ---------- INIT ----------
      this.slider = new Swiper(this, sliderOptions);
    }
  }

  customElements.define("card-slider", CardSlider);
}